import { NgModule, ErrorHandler } from '@angular/core';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { NativeStorage } from '@ionic-native/native-storage';
import { MusicControls } from '@ionic-native/music-controls';
import { IonicAudioModule, WebAudioProvider, CordovaMediaProvider, defaultAudioProviderFactory } from 'ionic-audio';
import { MyApp } from './app.component';
import { SignInPage } from '../pages/sign-in/sign-in';
import { PodcastListPage } from '../pages/podcast-list/podcast-list';
import { EpisodeListPage } from '../pages/episode-list/episode-list';
import { ExplorePage } from '../pages/explore/explore';

import { AudioService } from '../providers/audio-service';
import { PodcastService } from '../providers/podcast-service';
import { UserService } from '../providers/user-service';
import { SubscriptionService } from '../providers/subscription-service';
import { PreferencesService } from '../providers/preferences-service';
import { ControlsService } from '../providers/controls-service';
import { StripHtmlPipe } from '../pipes/strip-html/strip-html';
import { ShortenPipe } from '../pipes/shorten/shorten';

/**
 * Sample custom factory function to use with ionic-audio
 */
export function myCustomAudioProviderFactory() {
  return (window.hasOwnProperty('cordova')) ? new CordovaMediaProvider() : new WebAudioProvider();
}

@NgModule({
  declarations: [
    MyApp,
    SignInPage,
    PodcastListPage,
    EpisodeListPage,
    ExplorePage,
    StripHtmlPipe,
    ShortenPipe
  ],
  imports: [
    BrowserModule,
    HttpModule,
    IonicModule.forRoot(MyApp, {}, 
{
  links: [
    { loadChildren: '../pages/episode-list/episode-list.module#EpisodeListPageModule', name: 'EpisodeListPage', segment: 'episode-list', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/explore/explore.module#ExplorePageModule', name: 'ExplorePage', segment: 'explore', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/podcast-list/podcast-list.module#PodcastListPageModule', name: 'PodcastListPage', segment: 'podcast-list', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/sign-in/sign-in.module#SignInPageModule', name: 'SignInPage', segment: 'sign-in', priority: 'low', defaultHistory: [] }
  ]
}),
    IonicAudioModule.forRoot(defaultAudioProviderFactory)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    SignInPage,
    PodcastListPage,
    EpisodeListPage,
    ExplorePage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    NativeStorage,
    UserService,
    PodcastService,
    PreferencesService,
    SubscriptionService,
    PreferencesService,
    AudioService,
    MusicControls,
    ControlsService,
    {provide: ErrorHandler, useClass: IonicErrorHandler}
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts